import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ContactSales: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Enterprise plan
      </Typography>
      <Typography color="text.secondary" paragraph>
        Our team will help you with pricing, security review, and onboarding for Enterprise.
      </Typography>
      <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button variant="contained" href="mailto:sales@crudexpert.com?subject=Enterprise%20inquiry">
          Email sales
        </Button>
        <Button variant="outlined" onClick={() => navigate('/signup')}>
          Back to signup
        </Button>
      </Box>
    </Container>
  );
};

export default ContactSales;
